export default "__VITE_ASSET__CWl15p03__"